'use client';

import { c as _c } from "react/compiler-runtime";
import type { ComponentBaseProps, FormConfigProps } from '@sola/schema/lib/schema.ts';
import { AdditionalSettingsFormDynamic, FormDynamicVariantEnum } from '@sola/schema/lib/schema.ts';
import { submitLeadChurchForm, submitLeadEventForm, submitSubscription } from '@sola/skippy-sdk/requests.ts';
import { HeaderGroup } from '../../../molecules/header-group/header-group.tsx';
import { EventForm } from '../../../organisms/forms/event-form/event-form.tsx';
import { FormEmailSubscribe } from '../../../organisms/forms/form-email-subscribe/form-email-subscribe.tsx';
import { LeadForm } from '../../../organisms/forms/lead-form/lead-form.tsx';
export type FormDynamicCoreProps = FormConfigProps & ComponentBaseProps;
const formVariantMap: Record<FormDynamicVariantEnum, (s: AdditionalSettingsFormDynamic) => React.ReactNode> = {
  [FormDynamicVariantEnum.enum.subscription]: s => <FormEmailSubscribe subscriptionCode={s.subscriptionCode || 'Leads_General_Sign_Up'} onSubmit={submitSubscription} config={s} isFirstNameRequired isLastNameRequired />,
  [FormDynamicVariantEnum.enum.lead]: s => <LeadForm onSubmit={submitLeadChurchForm(s.leadType || 'contactme', s.subscriptionCode || 'Leads_General_Sign_Up')} config={s} />,
  [FormDynamicVariantEnum.enum.event]: s => <EventForm onSubmit={submitLeadEventForm(s.leadType || 'registration')} config={s} />
};
export const FormDynamicCore = t0 => {
  const $ = _c(23);
  let config;
  let props;
  let seoLevel;
  let settings;
  if ($[0] !== t0) {
    ({
      seoLevel,
      settings,
      config,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = config;
    $[2] = props;
    $[3] = seoLevel;
    $[4] = settings;
  } else {
    config = $[1];
    props = $[2];
    seoLevel = $[3];
    settings = $[4];
  }
  const source = (config ?? settings) as AdditionalSettingsFormDynamic;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[5] !== props || $[6] !== seoLevel || $[7] !== source) {
    const formDynamicSettings = AdditionalSettingsFormDynamic.parse({
      ...source,
      type: "formDynamic"
    });
    const formType = formDynamicSettings.formType ?? FormDynamicVariantEnum.enum.subscription;
    const hasHeaderContent = !!props.title || !!props.subtitle || Array.isArray(props.body) && props.body.length > 0;
    const renderForm = formVariantMap[formType];
    t4 = "component component--no-header";
    t1 = "container flex flex-col gap-roomy-xs lg:gap-roomy-sm";
    if ($[12] !== hasHeaderContent || $[13] !== props || $[14] !== seoLevel) {
      t2 = hasHeaderContent && <HeaderGroup {...props} seoLevel={seoLevel} />;
      $[12] = hasHeaderContent;
      $[13] = props;
      $[14] = seoLevel;
      $[15] = t2;
    } else {
      t2 = $[15];
    }
    t3 = formDynamicSettings && renderForm && renderForm(formDynamicSettings);
    $[5] = props;
    $[6] = seoLevel;
    $[7] = source;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t1 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
  }
  let t5;
  if ($[16] !== t1 || $[17] !== t2 || $[18] !== t3) {
    t5 = <div className={t1}>{t2}{t3}</div>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t4 || $[21] !== t5) {
    t6 = <section className={t4}>{t5}</section>;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
};